import api from "./Api";

class TransportadoraEmailService {
  GetTransportadoraEmail(payload) {
    return api.get("/v1/transportadoraEmail/" + payload).then((response) => {
      return response.data;
    });
  }

  PostTransportadoraEmail(payload) {
    return api.post("/v1/transportadoraEmail/", payload).then((response) => {
      return response.data;
    });
  }

  PutTransportadoraEmail(payload) {
    return api.put("/v1/transportadoraEmail/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteTransportadoraEmail(payload) {
    return api.delete("/v1/transportadoraEmail/" + payload).then((response) => {
      return response.data;
    });
  }

  GetTransportadoraEmailOData(payload) {
    return api.get("/OData/TransportadoraEmail" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new TransportadoraEmailService();
